function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleUserRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.002 28.016c.02-1.552.079-6.274 1.407-7.602.87-.87 2.439-1.955 4.415-3.055a2.964 2.964 0 001.497-2.143 2.985 2.985 0 00-.78-2.519c-.986-1.051-1.543-1.787-1.543-4.697 0-1.845 1.047-4 4-4 2.957 0 4.006 2.155 4.006 4 0 2.91-.559 3.646-1.545 4.697a2.988 2.988 0 00.718 4.662c1.976 1.1 3.545 2.185 4.415 3.055 1.328 1.328 1.387 6.05 1.418 7.586l-18.008.016zM25.007 19c-1.323-1.321-3.52-2.644-4.857-3.388a.99.99 0 01-.23-1.548c1.39-1.481 2.085-2.731 2.085-6.064 0-3-2.002-6-6.006-6-4.002 0-6.003 3-6.003 6 0 3.333.694 4.583 2.085 6.064a.989.989 0 01-.23 1.548c-1.339.744-3.535 2.067-4.857 3.388-1.678 1.676-1.95 5.456-1.994 8.991A1.986 1.986 0 006.99 30h18.02A1.986 1.986 0 0027 27.991c-.044-3.535-.316-7.315-1.993-8.991z",
    fill: props.color
  }));
}

export default SvgIconPeopleUserRexOutline;